var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0H12.25C12.6297 0 12.9435 0.282154 12.9932 0.648229L13 0.75V4H14.75C16.5449 4 18 5.45507 18 7.25V13.75C18 15.5449 16.5449 17 14.75 17H3.25C1.45507 17 0 15.5449 0 13.75V7.25C0 5.45507 1.45507 4 3.25 4H5V0.75C5 0.370304 5.28215 0.0565091 5.64823 0.00684667L5.75 0H12.25H5.75ZM14.75 5.5H3.25C2.2835 5.5 1.5 6.2835 1.5 7.25V13.75C1.5 14.7165 2.2835 15.5 3.25 15.5H14.75C15.7165 15.5 16.5 14.7165 16.5 13.75V7.25C16.5 6.2835 15.7165 5.5 14.75 5.5ZM11.5 1.5H6.5V4H11.5V1.5Z",
    fill: "#5CB1A3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.830661230c28b3557c8b1bc265b5e2aa.svg";
export { ForwardRef as ReactComponent };